import React, { Component } from "react"
import {
  InputCustom,
  SelectWithSearch,
  HttpError,
  InputMaskCustom
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModal } from "../modais"

export default class RelatorioAtestadoDeCapacidadeTecnicaForm extends Component {
  constructor() {
    super()
    this.onChangeData = this.onChangeData.bind(this)
    this.reset = this.reset.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.onChangeCPF = this.onChangeCPF.bind(this)
    this.onChangeRG = this.onChangeRG.bind(this)
    this.onChangeCidade = this.onChangeCidade.bind(this)
    this.onChangePreposto = this.onChangePreposto.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.getContratos = this.getContratos.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      data: "",
      cpf: "",
      rg: "",
      contrato: "",
      preposto: "",
      cidade: "",
      contratos: [],
      formError: ""
    }
  }
  reset() {
    this.setState({
      data: "",
      cpf: "",
      rg: "",
      contrato: "",
      preposto: "",
      cidade: ""
    })
  }

  componentWillMount() {
    this.getContratos()
  }
  getContratos() {
    ApiHelper.getAllContratos((contratos, error) => {
      if (contratos) {
        var mapped = Util.mapContratos(contratos)
        mapped.shift()
        this.setState({
          contratos: mapped
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeContrato(event) {
    this.setState({
      contrato: event,
      contrato_idError: ""
    })
  }
  onChangeCPF(e) {
    var newValue = e.target.value
    this.setState({
      cpf: newValue,
      cpfError: ""
    })
  }
  onChangeCidade(e) {
    var newValue = e.target.value
    this.setState({
      cidade: newValue,
      cidadeError: ""
    })
  }
  onChangeRG(e) {
    var newValue = e.target.value
    this.setState({
      rg: newValue,
      rgError: ""
    })
  }
  onChangePreposto(e) {
    var newValue = e.target.value
    this.setState({
      preposto: newValue,
      prepostoError: ""
    })
  }
  onChangeData(value) {
    var newValue = value
    this.setState({
      data: newValue,
      dataError: ""
    })
  }

  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Declaração do preposto",
      contrato_id:
        this.state.contrato === undefined || this.state.contrato === null
          ? null
          : this.state.contrato.value,
      data: Util.dateOnly(this.state.data),
      cpf: Util.unmaskField(this.state.cpf),
      rg: this.state.rg,
      preposto: this.state.preposto,
      cidade: this.state.cidade
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, (relatorio, error) => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Declaração do preposto.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.handleErrors(error)
        this.setState({
          formError: "Não existem baixas nesse período"
        })
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="row card" style={{ marginTop: 100 }}>
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="card card-content">
        <div className="row ">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <SelectWithSearch
            sizeClass="col-md-8"
            options={this.state.contratos}
            label="Contrato"
            error={this.state.contrato_idError}
            placeholder="Selecione um contrato ou deixe em branco para selecionar todos"
            onChange={this.onChangeContrato}
            value={this.state.contrato}
          />
        </div>
        <div className="row">
          <InputCustom
            sizeClass="col-md-3"
            type="text"
            label="Nome do preposto"
            error={this.state.prepostoError}
            onChange={this.onChangePreposto}
            value={this.state.preposto}
          />
          <InputCustom
            sizeClass="col-md-3"
            type="text"
            label="RG do preposto"
            error={this.state.rgError}
            onChange={this.onChangeRG}
            value={this.state.rg}
          />
          <InputMaskCustom
            mask="999.999.999-99"
            onChange={this.onChangeCPF}
            sizeClass="col-md-3"
            label="CPF do preposto"
            value={this.state.cpf}
            error={this.state.cpfError}
          />
        </div>
        <div className="row">
          <InputCustom
            sizeClass="col-md-3"
            type="text"
            label="Cidade da declaração"
            error={this.state.cidadeError}
            onChange={this.onChangeCidade}
            value={this.state.cidade}
          />
          <InputCustom
            sizeClass="col-md-3"
            type="date"
            label="Data da declaração"
            error={this.state.dataError}
            onChange={this.onChangeData}
            value={this.state.data}
          />
        </div>

        <div className="row">
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-left"
            data-background-color="as-blue"
          >
            Gerar
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/documentos/RelatorioDeclaracaoDoPrepostoForm.js